import { Heatmap } from "@ant-design/charts";

const RetentionHeatmap = ({ data }) => {
  // Find initial users per cohort for normalization (retention %)
  const cohortSizes = {};
  data.forEach(d => {
    if (d.month_offset === 0) {
      const cohortKey = d.is_preexisting ? "preexisting" : d.cohort_month;
      cohortSizes[cohortKey] = d.retained_users;
    }
  });

  // Transform data to include retention percentage
  const transformed = data.map(d => {
    const cohortKey = d.is_preexisting ? "preexisting" : d.cohort_month;
    const retention = cohortSizes[cohortKey]
      ? (d.retained_users / cohortSizes[cohortKey]) * 100
      : 0;

    return {
      cohort: d.is_preexisting ? "Preexistente" : d.cohort_month,
      month: d.month_offset,
      users: d.retained_users,
      retention: retention,
    };
  });

  const cohorts = [...new Set(transformed.map(d => d.cohort))];
  const sortedCohorts = [
  "Preexistente",
  ...cohorts.filter(c => c !== "Preexistente").sort(),
];

  const config = {
    data: transformed,
    xField: "month",
    yField: "cohort",
    colorField: "retention",
    shapeField: "square",
    sizeField: 'constant',
    tooltip: {
      title: (d) => `${d.cohort} • Month ${d.month}`,
      items: [
        {
          field: 'retention',
          name: 'Retention',
          valueFormatter: (v) => `${v.toFixed(1)}%`,
        },
        {
          field: 'users',
          name: 'Users',
          valueFormatter: (v) => `${v}`,
        },
      ],
    },
    label: {
      text: (d) => `${d.retention.toFixed(1)}%`,
      position: 'inside',
      style: {
        fill: '#fff',
        fontSize: 12,
        fontWeight: 500,
        pointerEvents: 'none',
      },
    },
    scale: {
      y: { domain: sortedCohorts },
      size: { range: [20, 20] }, // keep uniform squares
      color: {
        domain: [0, 100], // force 0% -> 100% mapping
        range: ["#f0f5ff", "#1d39c4"], 
        // optional: ["#f0f5ff", "#adc6ff", "#597ef7", "#2f54eb", "#1d39c4"]
      },
    },
    legend: {
      position: "bottom",
    },
    xAxis: {
      title: { text: "Months Since Activation" },
    },
    yAxis: {
      title: { text: "Cohort (Activation Month)" },
    },
  };

  return <Heatmap {...config} />;
};

export default RetentionHeatmap;
